import appContractors from "../../views/appSettings/contractors.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "contractors";
  const params = ["page", "limit"];

  $stateProvider.state("contractors", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appContractors,
      },
    },
    reloadOnSearch: false,
    data: { title: "Contractors" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/contractors/contractors.urls.js